import {
  StatusAborted,
  StatusError,
  StatusOK,
  StatusPending
} from '@backstage/core-components'
import { PatchStatus } from './catalogPatchAnnotations'

/**
 * `overridden` reads as OK deliberately: a more specific patch owning the field
 * is the mechanism working as designed, not a fault. Only `conflict` and
 * `dangling` need a human, and `no-live-targets` is the retirement signal —
 * done, rather than good or bad.
 */
export function PatchStatusIndicator(props: { status?: PatchStatus }) {
  switch (props.status) {
    case 'applied':
    case 'overridden':
      return <StatusOK>{props.status}</StatusOK>
    case 'pending':
      return <StatusPending>pending</StatusPending>
    case 'no-live-targets':
      return <StatusAborted>no live targets</StatusAborted>
    case 'conflict':
    case 'dangling':
      return <StatusError>{props.status}</StatusError>
    default:
      // The status pass runs a cycle behind the patch itself, so a freshly
      // ingested patch genuinely has no verdict yet.
      return <StatusPending>not yet reported</StatusPending>
  }
}
